function buildValidator({ validValues, errorMessage }) {
  return (value) => {
    const isValid = validValues.includes(value);
    /* eslint-disable no-console */
    if (!isValid) { console.error(`${errorMessage}: ${validValues.join(', ')}`); }
    /* eslint-enable no-console */
    return isValid;
  };
}

export {
  /* eslint-disable import/prefer-default-export */
  buildValidator,
};
